
<template>
    <div class="agInputSelect" :style="{'width': width + 'px !important'}">
        <b-form-select
            ref="select"
            class="agInputSelect-select"
            v-model="selectValue" 
            :disabled="disabled"
            @change="select_change">
            <optgroup 
                v-for="(group, key) in groups" 
                :key="key"
                :label="key">
                <option 
                    v-for="(option, index) in group" 
                    :key="index"
                    :value="option.value">
                    {{option.text}}
                </option>
            </optgroup>
        </b-form-select>
        <ag-sub-input
            v-if="useSubInput"
            ref="input"
            class="agInputSelect-subInput"
            :initText="inputValue"
            :workflow="workflow"
            :disabled="disabled"
            @change="input_keyup">
        </ag-sub-input>
        <b-input 
            v-else
            ref="input"
            class="agInputSelect-input"
            v-model="inputValue"
            autocomplete="false" 
            :disabled="disabled"
            @keyup="input_keyup">
        </b-input>
    </div>
    
</template>






<script>

// components
import SubInput from "comp/ui/SubInput";


// modules


export default {
    name: "ag-input-select",
    components: {
        "ag-sub-input": SubInput
    },
    props:{
        disabled: Boolean,
        inputModel: String,
        selectModel: Object,
        useSubInput: Boolean,
        groups: Object,
        workflow: Object,
        width: Number
    },
    data(){
        return {
            inputValue: null,
            selectValue: null
        };
    },
    computed: {

    },
    watch: {
      
    },

    created() {

    },

    mounted() {
      this.inputValue = this.inputModel;
      this.selectValue = this.selectModel;
    },

    methods: {

        // UI Events
        input_keyup($event) {
             if(this.useSubInput) { 
                var subInput = this.$refs["input"];
                this.inputValue = subInput.text;
             }
            this.selectValue = null;
            this.$emit("input_keyup", this.inputValue);
        },
        
         select_change() {
             // reset text
            this.inputValue = null;
             if(this.useSubInput) { 
                var subInput = this.$refs["input"];
                subInput.text = null;
            }

            this.$emit("select_change", this.selectValue);
        },

        // emitted Events


        // other
    }
}

</script>






<style scoped lang="css">

.agInputSelect {
    position: relative;
    display: inline-block;
}


.agInputSelect select {
    position: relative;
    width: 100% !important; 
    top: 0px;
    left: 0px;
}

.agInputSelect-input {
    position: absolute;
    width: calc(100% - 30px) !important;
    top: 0px;
    left: 0px;
    border: none !important;
    background: transparent !important;
}

.agInputSelect-input:focus {
    outline: none !important;
    border: none !important;
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
}

.agInputSelect-subInput {
    position: absolute;
    width: calc(100% - 30px) !important;
    top: 0px;
    left: 0px;
}


</style>

<style lang="css">

.agInputSelect-subInput input {
    position: absolute;
    top: 0px;
    left: 0px;
    border: none !important;
    background: transparent !important;
}

.agInputSelect-subInput input:focus {
    outline: none !important;
    border: none !important;
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
}


</style>



// WEBPACK FOOTER //
// src/components/ui/InputSelect.vue